import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { SparklesIcon, ThermometerSnowflakeIcon } from 'lucide-react';
export function UniqueMechanism() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[#0f172a] text-white py-20 md:py-32 relative overflow-hidden" data-id="element-167">
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-168">
        <div className="absolute top-20 right-[10%] w-2 h-2 rounded-full bg-[#d4a853] opacity-40" data-id="element-169"></div>
        <div className="absolute bottom-32 left-[15%] w-2 h-2 rounded-full bg-[#d4a853] opacity-30" data-id="element-170"></div>
        <SparklesIcon className="absolute top-1/3 left-[5%] w-4 h-4 text-[#d4a853] opacity-20" data-id="element-171" />
      </div>

      <div className="relative max-w-5xl mx-auto px-6" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 40
      }} transition={{
        duration: 0.8
      }} className="space-y-10" data-id="element-173">
          <div className="text-center space-y-4" data-id="element-174">
            <div className="flex justify-center mb-6" data-id="element-175">
              <ThermometerSnowflakeIcon className="w-16 h-16 text-[#d4a853]" data-id="element-176" />
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl text-white" data-id="element-177">
              El Protocolo de Enfriamiento Biológico
            </h2>
          </div>

          <div className="bg-[#1e293b] p-8 md:p-12 rounded-xl shadow-2xl space-y-6 text-lg md:text-xl leading-relaxed text-gray-300" data-id="element-178">
            <p data-id="element-179">
              Este método{' '}
              <span className="text-[#d4a853] font-semibold" data-id="element-180">
                no intenta convencer a tu mente
              </span>{' '}
              de que se duerma;{' '}
              <span className="text-white font-semibold" data-id="element-181">
                obliga a tu cuerpo a emitir la señal química de sueño profundo.
              </span>
            </p>

            <p data-id="element-182">
              Al hackear tu temperatura basal y usar técnicas de "descenso
              térmico", envías una señal directa a tu hipotálamo para que{' '}
              <span className="text-[#d4a853] font-semibold" data-id="element-183">
                apague el cortisol y libere melatonina natural
              </span>{' '}
              en cuestión de minutos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}